import request from "@/utils/request.js";

/**
 *手机号登录
 * @param params
 * @returns {AxiosPromise}
 */
export function pcloginPhone(params) {
  return request({
    url: "/coreService/api/app/user/pcloginPhone",
    method: "post",
    data: params
  });
}
/**
 *验证码登录
 * @param params
 * @returns {AxiosPromise}
 */
export function pcloginPhoneVerifyCode(params) {
  return request({
    url: "/coreService/api/app/user/pcloginPhoneVerifyCode",
    method: "post",
    data: params
  });
}
/**
 *获取验证码
 * @param params
 * @returns {AxiosPromise}
 */
export function loginPhoneSendCode(params) {
  return request({
    url: "/coreService/api/app/user/loginPhoneSendCode",
    method: "post",
    data: params
  });
}
/**
 *设置密码
 * @param params
 * @returns {AxiosPromise}
 */
export function forgetPassword(params) {
  return request({
    url: "/coreService/api/app/user/forgetPassword",
    method: "post",
    data: params
  });
}
/**
 *获取图片验证码
 * @param params
 * @returns {AxiosPromise}
 */
export function loginPhoneSendPictureCode(params) {
  return request({
    url: "/coreService/api/app/user/loginPhoneSendPictureCode",
    method: "post",
    closeLoading: true,
    data: params
  });
}
/**
 *手机验证码登录-获取验证码带图片滑动验证码
 * @param params
 * @returns {AxiosPromise}
 */
export function loginPhoneSendCodeWithPictureCode(params) {
  return request({
    url: "/coreService/api/app/user/loginPhoneSendCodeWithPictureCode",
    method: "post",
    closeLoading: true,
    data: params
  });
}
